
export enum COMM_GROUPS {
  PARENTS = "commGroups.parents",
  STUDENTS = "commGroups.students",
  SCHOOL = "commGroups.school",
  SYSTEM = "commGroups.system",
}

export enum COMM_TYPES_STUDENT {
  BEHAVIOUR_REPORT = "commType.student.behaviourReport",
  TASK_FEEDBACK = "commType.student.taskFeedback",
  EXPLANATION = "commType.student.explanation",
  OTHER = "commType.other.value",
}

export enum COMM_TYPES_PARENT {
  INTRODUCTORY = "commType.parent.introductory",
  POSITIVE_ACHIEVEMENT = "commType.parent.positiveAchievement",
  IMPROVEMENT = "commType.parent.improvement",
  SCHOOL_TRIP = "commType.parent.schoolTrip",
  EXTRACURRICULAR = "commType.parent.extracurricular",
  SAFETY = "commType.parent.safety",
  BEHAVIOUR_CONCERN = "commType.parent.behaviourConcern",
  RELOCATION = "commType.parent.relocation",
  FACULTY_BEHAVIOUR_CARD = "commType.parent.facultyBehaviourCard",
  RESTORATIVE_MEETING = "commType.parent.restorativeMeeting",
  NOTE_OF_PARENTAL_MEETING = "commType.parent.noteOfParentalMeeting",
  WHOLE_SCHOOL_BEHAVIOUR_TARGET = "commType.parent.wholeSchoolBehaviourTarget",
  DETENTION = "commType.parent.detention",
  OTHER = "commType.other.value",
}

export enum COMM_TYPES_SCHOOL {
  BEHAVIOUR_REPORT = "commType.school.behaviourReport",
  LEARNING_REPORT = "commType.school.learningReport",
  EXAM_REPORT = "commType.school.examReport",
  OTHER = "commType.other.value",
}

export enum COMM_TYPES_SYSTEM {
  SEEMIS = "commType.system.seemis",
  OTHER = "commType.other.value",
}

export enum LESSON_GROUPS {
  LESSON = "lesson",
}

const DURATIONS_MINUTES = ["15 minutes", "30 minutes", "45 minutes"];
const DURATIONS_HOURS = ["1 hour", "2 hours"];

export const LESSON_TYPES = [
  {
    value: "Lesson Plan",
    description: "A structured guide outlining objectives, activities, and resources for a lesson.",
    durations: [...DURATIONS_MINUTES, ...DURATIONS_HOURS],
  },
  {
    value: "Worksheet",
    description: "A set of exercises and/or questions for students to complete.",
    durations: [...DURATIONS_MINUTES, ...DURATIONS_HOURS],
  },
  {
    value: "Homework",
    description: "Assignments for students to complete outside of class.",
    durations: [...DURATIONS_MINUTES, ...DURATIONS_HOURS],
  },
  {
    value: "Test",
    description: "A formal assessment of student knowledge.",
    durations: [...DURATIONS_MINUTES, ...DURATIONS_HOURS],
  },
  {
    value: "Factsheet",
    description: "A short document for providing key information on a topic.",
    durations: [...DURATIONS_MINUTES, ...DURATIONS_HOURS],
  },
  {
    value: "wagoll",
    description: "What A Good One Looks Like - an example of high-quality work.",
    durations: [...DURATIONS_MINUTES, ...DURATIONS_HOURS],
  },
  {
    value: "Assembly Script",
    description: "A script for a school assembly.",
    durations: [...DURATIONS_MINUTES, ...DURATIONS_HOURS],
  },
  // TODO: Later.
  // {
  //   value: "Other",
  //   durations: [...DURATIONS_MINUTES, ...DURATIONS_HOURS, ...DURATIONS_DAYS],
  // },
];

export const COMM_TYPES = [
  {
    value: COMM_TYPES_PARENT.INTRODUCTORY,
    group: COMM_GROUPS.PARENTS,
  },
  {
    value: COMM_TYPES_PARENT.POSITIVE_ACHIEVEMENT,
    group: COMM_GROUPS.PARENTS,
  },
  {
    value: COMM_TYPES_PARENT.IMPROVEMENT,
    group: COMM_GROUPS.PARENTS,
  },
  {
    value: COMM_TYPES_PARENT.SCHOOL_TRIP,
    group: COMM_GROUPS.PARENTS,
  },
  {
    value: COMM_TYPES_PARENT.EXTRACURRICULAR,
    group: COMM_GROUPS.PARENTS,
  },
  {
    value: COMM_TYPES_PARENT.SAFETY,
    group: COMM_GROUPS.PARENTS,
  },
  {
    value: COMM_TYPES_PARENT.BEHAVIOUR_CONCERN,
    group: COMM_GROUPS.PARENTS,
  },
  {
    value: COMM_TYPES_PARENT.RELOCATION,
    group: COMM_GROUPS.PARENTS,
  },
  {
    value: COMM_TYPES_PARENT.FACULTY_BEHAVIOUR_CARD,
    group: COMM_GROUPS.PARENTS,
  },
  {
    value: COMM_TYPES_PARENT.RESTORATIVE_MEETING,
    group: COMM_GROUPS.PARENTS,
  },
  {
    value: COMM_TYPES_PARENT.NOTE_OF_PARENTAL_MEETING,
    group: COMM_GROUPS.PARENTS,
  },
  {
    value: COMM_TYPES_PARENT.WHOLE_SCHOOL_BEHAVIOUR_TARGET,
    group: COMM_GROUPS.PARENTS,
  },
  {
    value: COMM_TYPES_PARENT.DETENTION,
    group: COMM_GROUPS.PARENTS,
  },
  {
    value: COMM_TYPES_PARENT.OTHER,
    group: COMM_GROUPS.PARENTS,
  },
  {
    value: COMM_TYPES_STUDENT.BEHAVIOUR_REPORT,
    group: COMM_GROUPS.STUDENTS,
  },
  {
    value: COMM_TYPES_STUDENT.TASK_FEEDBACK,
    group: COMM_GROUPS.STUDENTS,
  },
  {
    value: COMM_TYPES_STUDENT.EXPLANATION,
    group: COMM_GROUPS.STUDENTS,
  },
  {
    value: COMM_TYPES_STUDENT.OTHER,
    group: COMM_GROUPS.STUDENTS,
  },
  {
    value: COMM_TYPES_SCHOOL.BEHAVIOUR_REPORT,
    group: COMM_GROUPS.SCHOOL,
  },
  {
    value: COMM_TYPES_SCHOOL.LEARNING_REPORT,
    group: COMM_GROUPS.SCHOOL,
  },
  {
    value: COMM_TYPES_SCHOOL.EXAM_REPORT,
    group: COMM_GROUPS.SCHOOL,
  },
  {
    value: COMM_TYPES_SCHOOL.OTHER,
    group: COMM_GROUPS.SCHOOL,
  },
  {
    value: COMM_TYPES_SYSTEM.SEEMIS,
    group: COMM_GROUPS.SYSTEM,
  },
  {
    value: COMM_TYPES_SYSTEM.OTHER,
    group: COMM_GROUPS.SYSTEM,
  },
];

export enum LEARNING_REQUIREMENTS {
  UNSET = "learningRequirement.unset",
  DYSLEXIA = "learningRequirement.dyslexia",
  POOR_MEMORY = "learningRequirement.poorMemory",
  LANGUAGE_PROCESSING_DISORDER = "learningRequirement.languageProcessingDisorder",
  READING_WRITING = "learningRequirement.readingWriting",
  DYSCALCULIA = "learningRequirement.dyscalculia",
  AUTISM = "learningRequirement.autism",
  OTHER = "learningRequirement.other",
}

export enum AGE_GROUPS {
  UNSET = "ageGroup.unset",
  NINE_AND_UNDER = "ageGroup.9AndUnder",
  TEN_TO_ELEVEN = "ageGroup.10To11",
  TWELVE_TO_THIRTEEN = "ageGroup.12To13",
  FOURTEEN_TO_FIFTEEN = "ageGroup.14To15",
  SIXTEEN_TO_SEVENTEEN = "ageGroup.16To17",
  EIGHTEEN_AND_OVER = "ageGroup.18AndOver",
  OTHER = "ageGroup.other",
}

export type CommType = {
  value: string;
  group: string;
};
export type SubmissionPayload = {
  type:
  | COMM_TYPES_PARENT
  | COMM_TYPES_STUDENT
  | COMM_TYPES_SCHOOL
  | COMM_TYPES_SYSTEM;
  recipient: COMM_GROUPS;
  from: string;
  subject: string;
  body: string;
  showAccessibilityOptions: "yes" | "no";
  age: AGE_GROUPS;
  learning_requirement: LEARNING_REQUIREMENTS;
  language?: string;
  format: "email" | "letter" | "SeeMIS";
  selectedTemplate?: string;
};